import React, {ReactElement} from 'react';
import PasswordGenerationContent from '../../../Components/SFTP/PasswordGenerationContent';
import PageHeader from '../../../Components/shared/PageHeader';
import './index.scss';

const PasswordGeneration = (): ReactElement => {
    return (
        <div className='sftp-password-generation'>
            <PageHeader className='sftp-password-generation__page-header' isLanguageSelector={false}/>

            <div className='sftp-password-generation__layout'>
                <PasswordGenerationContent/>
            </div>
        </div>
    );
};

export {PasswordGeneration as TestablePasswordGeneration};
export default PasswordGeneration;
